export interface CellTableArtifactIdentity {
  resultType?: string;
  optionKey?: string;
  artifactUrl?: string;
  urlForGetRequest?: string;
}

// More specific artifact kinds come first. A cells-table result can also carry another parquet, and that file's own
// name has to win over the result type or both rows read as the same cell table.
const ARTIFACT_LABELS: Array<[RegExp, string]> = [
  [/pips_area_instances_table|area_instances_table/, 'Area instances'],
  [/pips_instances_table|slide_detections_table/, 'Spot detections'],
  [/nuclei_segmentations|slide_inference_nuclei/, 'Nuclei segmentation'],
  [/whole_cell_segmentations|slide_inference_cell_segmentation|cell_segmentation/, 'Cell segmentation'],
  [/markers_probabilities/, 'Marker probabilities'],
  [/cell_attributes/, 'Cell attributes'],
  [/cell_quantification/, 'Cell quantification'],
  [/pips_cells_table|cells_table/, 'Cell table'],
];

// Undefined when the file does not identify itself. Callers then keep the run name, or add the column count when
// several unnamed tables would otherwise read the same.
export const describeCellTableArtifact = (file: CellTableArtifactIdentity): string | undefined => {
  const haystack = [file.artifactUrl, file.optionKey, file.resultType, file.urlForGetRequest].filter(Boolean).join(' ');
  return ARTIFACT_LABELS.find(([pattern]) => pattern.test(haystack))?.[1];
};
